module.exports = __webpack_public_path__ + "static/media/trustly.4f2df12d.png";